<template>
  <div class="listing-dropdown">
    <vue-dropdown :config="config" @setSelectedOption="setNewSelectedOption($event)">
    </vue-dropdown>
  </div>
</template>

<script>
import vueDropdown from '../dropdown/dropdown.vue';
export default {
  name: 'product-listing-dropdown',
  components: {
    vueDropdown,
  },
  props: {
    option: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      config: {
        options: this.option,
        placeholder: '',
        backgroundColor: '#068ef3',
        textColor: '#fff',
      },
    };
  },
  mounted() {
    for (let i = 0; i < this.option.length; i++) {
      if (this.option[i].isactive) this.config.placeholder = this.option[i].tabname;
    }
  },
  methods: {
    setNewSelectedOption(selectedOption) {
      this.config.placeholder = selectedOption.tabname;
      window.location.href = selectedOption.anchor;
    },
  },
};
</script>
